module.exports = __webpack_public_path__ + "static/media/Hawk238_4c.d5a5feef.svg";